// extracted by mini-css-extract-plugin
module.exports = {"card":"_1_Le7","stretch-vertically":"_2xVfX","stretchVertically":"_2xVfX"};